import axios from 'axios';
import { useAtom, useSetAtom } from 'jotai';
import { environment } from '../../environment';
import { errorCatcher, useSnackbar } from '../../hooks';
import { useLogin } from '../login';
import { IInventoryScanResult, inventoryScanLoadingAtom, inventoryScanResultAtom } from './types';

type UseInventoryScan = [IInventoryScanResult | null, {
  scan: (value: string, kind?: 'PO' | 'ITEM') => Promise<IInventoryScanResult | null>;
}];

export const useInventoryScan = (): UseInventoryScan => {
  const [result, setResult] = useAtom(inventoryScanResultAtom);
  const setLoading = useSetAtom(inventoryScanLoadingAtom);
  const [, setSnackbar] = useSnackbar();
  const [, authToken, loginFunctions] = useLogin();

  const scan = async (value: string, kind?: 'PO' | 'ITEM') => {
    try {
      setLoading(true);
      const { data } = await axios.post(`${environment.baseUrl}/api/v2/inventory/scan`, { value, kind }, {
        headers: { 'X-Wallmates-Auth': authToken }
      });
      setResult(data as IInventoryScanResult);
      return data as IInventoryScanResult;
    } catch (e: any) {
      errorCatcher(e, loginFunctions.logout);
      setSnackbar({ show: true, snackbarLevel: 'error', text: 'Scan failed. Please try again.' });
      return null;
    } finally {
      setLoading(false);
    }
  };

  return [result, { scan }];
}


